/**
 * Generated runtime TestId mirror for frontend/src/components/shared/EmptyState.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const EmptyStateTestIds = {
  emptyState: "empty-state",
  emptyStateAction: "empty-state-action",
  emptyStateDescription: "empty-state-description",
  emptyStateIcon: "empty-state-icon",
  emptyStateTitle: "empty-state-title"
} as const;
